import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedTabGroupComponent } from "./med-tab-group.component";
import { MedTabModule } from "../med-tab/med-tab.module";

@NgModule({
  declarations: [
    MedTabGroupComponent,
  ],
  imports: [
    CommonModule,
    MedTabModule,
  ],
  exports: [
    MedTabGroupComponent,
  ],
})
export class MedTabGroupModule { }
